import { useSnackbar } from 'notistack';
import { useState } from 'react';
// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useAuth from "../../../hooks/useAuth";
import useResponsive from "../../../hooks/useResponsive";
// components
import DIOText from '../../../components/DIOText';
import SvgIconStyle from '../../../components/SvgIconStyle';
// util
import axios from '../../../utils/axios';


export default function JobPostHelpDialog({ open, closeDialog, jobPostId }) {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmit, setIsSubmit] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const formatPhone = (phone) => {
    const cleaned = ('' + phone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
    if (match) {
      return match[1] + '-' + match[2] + '-' + match[3];
    }
    return phone;
  }

  const handleError = (error) => {
    console.error(error);
    if (error.response && error.response.status === 400) {
      enqueueSnackbar(error.response.data.message, { variant: 'warning' });
    } else {
      enqueueSnackbar("저장에 실패하였습니다. 관리자에 문의해주세요.", { variant: 'warning' });
    }
  };

  const setPhoneMeeting = async () => {
    setIsSubmit(true);
    const companyId = user?.employee.company[0].id;
    try {
      await axios.post(`/api/company/${companyId}/job-posts/${jobPostId}/set-phone-meeting/`);
      if (smUp) {
        enqueueSnackbar('요청이 접수되었습니다');
      } else {
        enqueueSnackbar('요청이 접수되었습니다', {anchorOrigin: { vertical: 'bottom', horizontal: 'center' }});
      }
      setIsSubmit(false);
      setSubmitted(true);
    } catch (error) {
      setIsSubmit(false);
      handleError(error);
    }
  };

  const close = async () => {
    setSubmitted(false);
    closeDialog();
  }

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="xs">
      {/* contents */}
      {!submitted && (
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <SvgIconStyle src={`/icons/ic_headphone.svg`} sx={{ width: 28, height: 28, color: 'error.main' }} />
        <Typography variant="h5" sx={{ wordBreak: "keep-all" }} paragraph>
          공고 작성과 관련하여 <DIOText />와 상담이 필요하신가요?
        </Typography>
        <Typography variant="subtitle1">
          {formatPhone(user?.phone)}
        </Typography>
        <Typography>
          가입시 등록하신 이 번호로 전화 드릴게요.
        </Typography>
      </DialogContent>
      )}
      {submitted && (
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Typography variant="h5" sx={{ wordBreak: "keep-all" }} paragraph>
          빠른 시일 내에 전화드릴게요.
        </Typography>
        <Typography sx={{ wordBreak: "keep-all" }}>
          확인을 선택하고, 나머지 공고를 작성해주시면 미팅 진행이 더 수월합니다. 
        </Typography>
        <Typography sx={{ wordBreak: "keep-all" }}>
          공고 작성이 어렵다면 작성을 멈춰도 괜찮습니다.
        </Typography>
      </DialogContent>
      )}
      {/* buttons */}
      {!submitted && (
      <DialogActions sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack
          display="flex"
          justifyContent="flex-end"
          direction={{ xs: "column-reverse", sm: "row" }}
          sx={{ width: 1 }}
          spacing={2}
        >
          <LoadingButton
            onClick={closeDialog}
            size="large"
            sx={{ px: 5 }}
            loading={isSubmit}
          >
            취소
          </LoadingButton>
          <LoadingButton
            variant="contained"
            onClick={setPhoneMeeting}
            size="large"
            sx={{ px: 5 }}
            loading={isSubmit}
          >
            전화 상담 요청
          </LoadingButton>
        </Stack>
      </DialogActions>
      )}
      {submitted && (
      <DialogActions sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack
          display="flex"
          justifyContent="flex-end"
          direction={{ xs: "column-reverse", sm: "row" }}
          sx={{ width: 1 }}
        >
          <LoadingButton
            variant="contained"
            onClick={close}
            size="large"
            sx={{ px: 5 }}
            loading={isSubmit}
          >
            확인
          </LoadingButton>
        </Stack>
      </DialogActions>
      )}
    </Dialog>
  )
}
